import React, { useEffect, useState } from 'react';
import { useAuthState } from '../../auth/authContext';
import client from '../../../graphql/client';
import FanGenreButtonList from '../../components/styled/FanGenreButtonList';
import HeaderTwo from '../../components/styled/HeaderTwo';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import View from '../../components/styled/View';

import styles from './styles';
import { SUB_TITLE, TITLE } from './constants';

export default function ArtistGenresScreen({ navigation, route }) {
  const { cognitoId } = useAuthState();
  const values = route.params.formikValues;
  const artistGenres = route?.params?.artistGenres;
  const isCreate = route.params.isCreate;

  const [updatedGenres, setUpdatedGenres] = useState(artistGenres || []);
  const [genresList, setGenres] = useState<any>();

  // This will be reactivated when there are enough subGenres
  const createGenresObject = (data) => {
    let obj = {};
    data.items.map((item) => {
      const doesSuperGenreExist = obj.hasOwnProperty(item.superGenre);
      if (doesSuperGenreExist) {
        obj[item.superGenre].push(item);
      } else {
        obj[item.superGenre] = [item];
      }
      return obj;
    });
    return obj;
  };

  const createSubGenresObject = (data) => {
    const obj = data.items.map((item) => {
      return item;
    });
    return obj;
  };

  const updateArtistGenreConnection = async () => {
    if (!artistGenres) {
      updatedGenres.map(async (genre) => {
        const artistGenreObj = {
          artistGenreArtistId: cognitoId,
          artistGenreGenreId: genre.id,
        };
        await client.createAnArtistGenre(artistGenreObj);
      });
    } else {
      await Promise.all(
        artistGenres.map(async (artistGenre) => {
          await client.deleteAnArtistGenre({ id: artistGenre.agId });
        }),
      );
      await Promise.all(
        updatedGenres.map(async (genre) => {
          const artistGenreObj = {
            artistGenreArtistId: cognitoId,
            artistGenreGenreId: genre.id,
          };
          await client.createAnArtistGenre(artistGenreObj);
        }),
      );
      navigation.navigate('Profile', { newGenres: updatedGenres });
    }
  };

  const createGenreList = async () => {
    const rawGenreData = await client.getGenres();
    //const items = createGenresObject(rawGenreData);
    const items = createSubGenresObject(rawGenreData);
    setGenres(items);
  };

  const saveProfile = async () => {
    const { artistName, bio, hometown } = values;
    // EXAMPLE OF HOW WE CALL THE GRAPHQL ENDPOINT
    const artistDetails = {
      artistName,
      hometown,
      biography: bio,
      cognitoId,
    };
    await client.createAnArtist(artistDetails);
    updateArtistGenreConnection();
    navigation.navigate('CreateSession', { artistGenres: updatedGenres });
  };

  const updateNewGenres = (selectedGenre: any) => {
    const clonedGenres = updatedGenres.slice(); // ensures we don't mutate the original array
    const indexToRemove = clonedGenres.findIndex(
      (item) => item.id === selectedGenre.id,
    );
    clonedGenres.find((item) => item?.id == selectedGenre.id)
      ? clonedGenres.splice(indexToRemove, 1)
      : clonedGenres.push({
          id: selectedGenre.id,
          genre: selectedGenre.genre,
          agId: 'new',
        });
    setUpdatedGenres(clonedGenres);
  };

  useEffect(() => {
    createGenreList();
  }, []);

  if (!genresList) return null;
  const limitReached = updatedGenres.length === 3;
  const minSelectedThreshold = updatedGenres.length === 1;
  return (
    <View style={styles.container}>
      <HeaderTwo title={TITLE} style={styles.title} />
      <HeaderTwo title={SUB_TITLE} style={styles.subHeader} />
      {/* <SuperGenreButtonList
        genres={genresList}
        activeGenres={updatedGenres}
        onPress={updateNewGenres}
        limitReached={limitReached}
        minSelectedThreshold={minSelectedThreshold}
      /> */}
      <FanGenreButtonList
        genres={genresList}
        activeGenres={updatedGenres}
        onPress={updateNewGenres}
        limitReached={limitReached}
        minSelectedThreshold={minSelectedThreshold}
      />
      <View style={styles.buttonContainer}>
        {!isCreate && (
          <LinearGradientButton
            title="Save"
            onPress={() => updateArtistGenreConnection()}
          />
        )}
        {isCreate && (
          <LinearGradientButton title="Save" onPress={() => saveProfile()} />
        )}
      </View>
    </View>
  );
}
